module.exports = __webpack_public_path__ + "img/1.496556df.jpg";